import React from 'react'
import { Container, Col, Row, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faCogs, faHome, faRss, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { Disqus, CommentCount } from 'gatsby-plugin-disqus'

import 'antd/dist/antd.css';
import 'bootstrap/dist/css/bootstrap.min.css';


const getIcon = (icon) => {
    if (icon == 'home' || icon === "") {
        return faHome
    }
    else if( icon == 'project') {
        return faCogs
    }
    else if( icon == 'blog') {
        return faRss
    }
    else if( icon == 'post') {
        return faWindowMaximize
    }
    else {
        return faInfoCircle
    }
}

export default function Window({children, title = '', url='', icon='blog', titleImage='', category='blog'}) {
    const disqusConfig = {
        url: url,
        identifier: title,
        title: title,
    }
    
  return (
      <Container style={{ marginTop: '5rem', marginBottom: '5rem' }}>
          <Row>
			  <Col>
				  <Card style={{ width: '100%' }}>
					  <Card.Header className="cloud-sky" style={{backgroundColor: '#cae4ed'}}>
                        <FontAwesomeIcon icon={getIcon(icon)} style={{color: 'white'}} />
					  </Card.Header>
					  <Card.Body>
						  {children}
					  </Card.Body>

          { 
              icon=='post' ?
              <div className="cloud-sky" style={{padding: "10%"}}>
                  <CommentCount config={disqusConfig} placeholder={'...'} />
                  <Disqus config={disqusConfig} />
              </div>
              :
              <></> 
          }
                      
				  </Card>
			  </Col>
          </Row>
      </Container>
  )
}


